<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-xl">
        <b-card>
          <template slot="header">
            <div class="form-row">
              <div class="form-group col-md">
                  <treeselect ref="structureTreeselect"
                              v-model="surveyValue"
                              valueFormat="object"
                              :auto-load-root-options="false"
                              :placeholder="$t('Webportal.SurveyFilter.Placeholder')"
                              :options="structureItems"
                              :disabled="isExporting"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              showCountOf="LEAF_DESCENDANTS"
                              :disable-branch-nodes="true"
                              @input="surveyFilterInput">
                  </treeselect>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md">
                  <treeselect ref="waveTreeselect"
                              v-model="waveValue"
                              :auto-load-root-options="false"
                              :placeholder="$t('Webportal.WaveFilter.Placeholder')"
                              :options="waveItems"
                              :disabled="noSurveySelected || isExporting"
                              :disableFuzzyMatching="true"
                              :multiple="true"
                              :showCount="true"
                              showCountOf="LEAF_DESCENDANTS"
                              :flat="true"
                              :defaultExpandLevel="1"
                              :disable-branch-nodes="true">
                  </treeselect>
              </div>
              <div class="form-group col-md">
                  <treeselect ref="scenarioTreeselect"
                              v-model="scenarioValue"
                              :auto-load-root-options="false"
                              :placeholder="$t('Webportal.ScenarioFilter.Placeholder')"
                              :options="scenarioItems"
                              :disabled="noSurveySelected || isExporting"
                              :disableFuzzyMatching="true"
                              :multiple="true"
                              :showCount="true"
                              showCountOf="LEAF_DESCENDANTS"
                              :flat="true"
                              :defaultExpandLevel="1"
                              :disable-branch-nodes="true">
                  </treeselect>
              </div>
              <div class="form-group col-md">
                <treeselect ref="propertyTreeselect"
                            v-model="propertyValue"
                            :auto-load-root-options="false"
                            :placeholder="$t('Webportal.PropertyValueFilter.Placeholder')"
                            :options="propertyItems"
                            :disabled="noSurveySelected || isExporting"
                            :disableFuzzyMatching="true"
                            :multiple="true"
                            :showCount="true"
                            showCountOf="LEAF_DESCENDANTS"
                            :flat="true"
                            :defaultExpandLevel="1"
                            :disable-branch-nodes="true">
                </treeselect>
              </div>
            </div>
          </template>

          <!-- Export type Radio-Selector -->
          <b-form-group v-if="isMSMUser"
                        :label-cols-sm="2" :label="$t('Webportal.ExportType')" label-class="font-weight-bold pt-0">
            <b-form-radio-group buttons button-variant="outline-secondary"
                                v-model="exportTypeValue"
                                :disabled="noSurveySelected || isExporting">
              <b-form-radio :value="ExportType.Customer">{{ $t('Webportal.Customer') }}</b-form-radio>
              <b-form-radio :value="ExportType.QualityAssurance">{{ $t('Webportal.QualityAssurance') }}</b-form-radio>
              <b-form-radio :value="ExportType.Points">{{ $t('Webportal.Points') }}</b-form-radio>
            </b-form-radio-group>
          </b-form-group>

          <!-- Target group selection -->
          <b-form-group v-if="isMSMUser && exportTypeCustomerSelected"
                        :label-cols-sm="2" :label="$t('Webportal.TargetGroup')" label-class="font-weight-bold"
                        :disabled="noSurveySelected || targetGroups.length == 0 || isExporting || !this.exportTypeCustomerSelected">
            <b-form-select class="col-xl-2 col-lg-2 col-md-3 col-sm-4" v-model="targetGroupValue">
                <option v-for="targetGroup in targetGroups" :key="targetGroup" :value="targetGroup">
                  {{ $t('Webportal.TargetGroup') }} {{ targetGroup }}
                </option>
            </b-form-select>
          </b-form-group>

          <!-- Customer Status selection -->
          <b-form-group v-if="isMSMUser && exportTypeCustomerSelected"
                        :label-cols-sm="2" :label="$t('Webportal.Status')" label-class="font-weight-bold"
                        :disabled="noSurveySelected || isExporting || !this.exportTypeCustomerSelected">
            <b-form-group>
              <div class="form-row">
                <div class="col-auto">
                  <b-form-input v-model="statusMinValue"
                                type="number"
                                min="0"
                                max="400"
                                style="max-width:5em"></b-form-input>
                </div>
                <div class="col-auto">
                  <label class="col-form-label">{{ $t('Webportal.RangeTo') }}</label>
                </div>
                <div class="col-auto">
                  <b-form-input v-model="statusMaxValue"
                                type="number"
                                min="0"
                                max="400"
                                style="max-width:5em"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="includeTestchecks"
                              :disabled="noSurveySelected || isExporting">
                              {{ $t('Webportal.Include') }} {{ $t('Webportal.IncludeTestchecks') }}</b-form-checkbox>
            </b-form-group>
          </b-form-group>

          <!-- QA Status selection -->
          <b-form-group v-if="isMSMUser && exportTypeQASelected"
                        :label-cols-sm="2" :label="$t('Webportal.Status')" label-class="font-weight-bold"
                        :disabled="noSurveySelected || isExporting || !this.exportTypeQASelected">
            <b-form-group>
              <div class="form-row">
                <div class="col-auto">
                  <b-form-input v-model="statusMinValueQA"
                                type="number"
                                min="0"
                                max="400"
                                style="max-width:5em"></b-form-input>
                </div>
                <div class="col-auto">
                  <label class="col-form-label">{{ $t('Webportal.RangeTo') }}</label>
                </div>
                <div class="col-auto">
                  <b-form-input v-model="statusMaxValueQA"
                                type="number"
                                min="0"
                                max="400"
                                style="max-width:5em"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="includeTestchecks"
                              :disabled="noSurveySelected || isExporting">
                              {{ $t('Webportal.Include') }} {{ $t('Webportal.IncludeTestchecks') }}</b-form-checkbox>
            </b-form-group>
          </b-form-group>

          <!-- Points Status selection -->
          <b-form-group v-if="isMSMUser && exportTypePointsSelected"
                        :label-cols-sm="2" :label="$t('Webportal.Status')" label-class="font-weight-bold"
                        :disabled="noSurveySelected || isExporting || !this.exportTypePointsSelected">
            <b-form-group>
              <div class="form-row">
                <div class="col-auto">
                  <b-form-input v-model="statusMinValuePoints"
                                type="number"
                                min="0"
                                max="400"
                                style="max-width:5em"></b-form-input>
                </div>
                <div class="col-auto">
                  <label class="col-form-label">{{ $t('Webportal.RangeTo') }}</label>
                </div>
                <div class="col-auto">
                  <b-form-input v-model="statusMaxValuePoints"
                                type="number"
                                min="0"
                                max="400"
                                style="max-width:5em"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="includeTestchecks"
                              :disabled="noSurveySelected || isExporting">
                              {{ $t('Webportal.Include') }} {{ $t('Webportal.IncludeTestchecks') }}</b-form-checkbox>
            </b-form-group>
          </b-form-group>

          <b-form-group v-if="exportTypeCustomerSelected || exportTypeQASelected"
                        :label-cols-sm="2" label-class="font-weight-bold">
            <template slot="label">
              <b-badge style="background-color: #007bff;">&nbsp;&nbsp;</b-badge>
              {{ $t('Webportal.Kpis') }}
            </template>
            <b-form-group>
              <treeselect ref="kpiTreeselect"
                          v-model="kpiValue"
                          :auto-load-root-options="false"
                          :placeholder="$t('Webportal.KpiFilter.Placeholder')"
                          :options="kpiItems"
                          valueFormat="object"
                          :disabled="noSurveySelected || isExporting"
                          :disableFuzzyMatching="true"
                          :multiple="true"
                          :showCount="true"
                          showCountOf="LEAF_DESCENDANTS"
                          :defaultExpandLevel="1">
              </treeselect>
            </b-form-group>
            <b-form-checkbox v-model="includeKpiPoints" v-show="hasPointSelection"
                             :disabled="noSurveySelected || isExporting">
                             {{ $t('Webportal.Include') }} {{ $t('Webportal.KpiPoints') }}</b-form-checkbox>
          </b-form-group>

          <b-form-group v-if="exportTypeCustomerSelected || exportTypeQASelected" :label-cols-sm="2"
                        label-class="font-weight-bold pt-0">
            <template slot="label">
              <b-badge style="background-color: #6c757d;">&nbsp;&nbsp;</b-badge>
              {{ $t('Webportal.ClusterResults') }}
            </template>
            <b-form-checkbox inline v-model="includeClusterPercentages" :disabled="noSurveySelected || isExporting">
                            {{ $t('Webportal.Include') }} {{ $t('Webportal.ClusterResults') }}</b-form-checkbox>
            <b-form-checkbox inline v-show="hasPointSelection"
                             v-model="includeClusterPoints" :disabled="noSurveySelected || isExporting || !includeClusterPercentages">
                            {{ $t('Webportal.Include') }} {{ $t('Webportal.ClusterPoints') }}</b-form-checkbox>
          </b-form-group>

          <!-- Includes section -->
          <b-form-group :label-cols-sm="2" :label="$t('Webportal.Include')" label-class="font-weight-bold pt-0">
            <b-form-checkbox-group stacked
                                  v-model="includedDataValue"
                                  :disabled="noSurveySelected || isExporting">
              <b-form-checkbox v-show="exportTypePointsSelected" :value="IncludedData.CheckInfo">{{ $t('Webportal.CheckInfo') }}</b-form-checkbox>
              <b-form-checkbox :value="IncludedData.LocationInfo">{{ $t('Webportal.LocationInfo') }}</b-form-checkbox>
              <b-form-checkbox v-show="exportTypeQASelected || exportTypeCustomerSelected"
                              :value="IncludedData.Properties">{{ $t('Webportal.Properties') }}</b-form-checkbox>
              <b-form-checkbox v-show="exportTypeQASelected || exportTypeCustomerSelected"
                              :value="IncludedData.QuestionsWithoutAnswers">{{ $t('Webportal.QuestionsWithoutAnswers') }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>

          <div class="form-row">
            <div class="col-md-auto">
              <b-alert :show="noDataAlert"
                      dismissible
                        @dismissed="noDataAlert=0"
                      variant="warning">
                {{ $t('Webportal.NoDataFound') }}
              </b-alert>
              <b-button variant="primary"
                        :disabled="noSurveySelected || isExporting"
                        @click="downloadRawData()">
                {{ $t('Webportal.Download') }}
                <font-awesome-icon icon="download" />
              </b-button>
            </div>
            <div class="col-md-1" v-bind:class="{ inlineSpinner: isExporting }"></div>
          </div>

        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import DownloadFileMixin from '@/mixins/DownloadFileMixin'

import EventBus from '@/services/EventBus.js';
import AuthenticationService from '@/services/AuthenticationService'
import SurveysService from '@/services/SurveysService'
import ReportsService from '@/services/ReportsService'

const ExportType = {
  Customer: 1,
  QualityAssurance: 2,
  Points: 3,
}

const IncludedData = {
  QuestionsWithoutAnswers: 1,
  LocationInfo: 3,
  Properties: 4,
  KpiPoints: 5,
  CheckInfo: 6
}

export default {
  name: "RawData",

  mixins: [ AppConfig, DownloadFileMixin ],

  data () {
    return {
      // Filter properties
      structureItems: [],                   // Data items for structure treeselect
      surveyValue: null,                    // Selected structure items
      waveItems: [],                        // Data items for wave treeselect
      waveValue: [],                        // Selected wave items
      scenarioItems: [],                    // Data items for scenarios
      scenarioValue: [],                    // Selected scenarios
      propertyItems: [],                    // Data items for property treeselect
      propertyValue: [],                    // Selected property items
      targetGroups: [],
      targetGroupValue: null,
      statusMinValue: 220,                  // Customer Min/Max Values
      statusMaxValue: 220,
      statusMinValueQA: 100,                // Quality Assurance Min/Max Values
      statusMaxValueQA: 299,
      statusMinValuePoints: 220,            // Points Min/Max Values
      statusMaxValuePoints: 220,
      includeTestchecks: false,

      ExportType: ExportType,
      exportTypeValue: ExportType.Customer,
      includeKpiPoints: true,
      kpiItems: [],                        // Data items for kpi treeselect
      kpiValue: [],                        // Selected kpi items
      includeClusterPercentages: false,
      includeClusterPoints: false,
      IncludedData: IncludedData,
      includedDataValue: [
        IncludedData.LocationInfo,
        IncludedData.Properties,
        IncludedData.CheckInfo
      ],

      isExporting: false,
      noDataAlert: 0
    }
  },

  computed: {
    isMSMUser: function () {
      return AuthenticationService.isMSMUser;
    },

    hasPointSelection: function() {
      return this.hasRawDataPointSelection() || (this.exportTypeQASelected && this.isMSMUser);
    },

    noSurveySelected: function () {
      return _.isEmpty(this.surveyValue);
    },

    exportTypeCustomerSelected: function () {
      return this.exportTypeValue === ExportType.Customer;
    },

    exportTypeQASelected: function () {
      return this.exportTypeValue === ExportType.QualityAssurance;
    },

    exportTypePointsSelected: function () {
      return this.exportTypeValue === ExportType.Points;
    },

    getMinimumStatus: function() {
      if (!this.isMSMUser) {
        return null
      }
      if (this.exportTypeQASelected) {
        return this.statusMinValueQA
      }
      if (this.exportTypePointsSelected) {
        return this.statusMinValuePoints
      }
      if (this.exportTypeCustomerSelected) {
        return this.statusMinValue
      }
      return null
    },

    getMaximumStatus: function() {
     if (!this.isMSMUser) {
        return null
      }
      if (this.exportTypeCustomerSelected) {
        return this.statusMaxValue
      }
      if (this.exportTypeQASelected) {
        return this.statusMaxValueQA
      }
      if (this.exportTypePointsSelected) {
        return this.statusMaxValuePoints
      }
      return null
    },

    filter: function() {
      // Returns an array of all KPI ids recursively for the given node
      let returnKpiIds = (obj) => {
          return _.concat(obj.id && obj.id[0] === 'K' ? obj.id.substring(1) : [],
              obj.children ? _.flatMapDeep(obj.children, returnKpiIds) : []);
      };

      let result = {
        surveyIds: [],
        waveIds: this.waveValue,
        scenarioIds: this.scenarioValue,
        propertyIds: this.propertyValue,
        targetGroup: this.exportTypeCustomerSelected ? this.targetGroupValue : null,
        kpiIds: !_.isEqual(this.kpiValue, this.kpiItems) ? _.flatMapDeep(this.kpiValue, returnKpiIds) : null,
        surveyInstanceStatusMinimum: this.getMinimumStatus,
        surveyInstanceStatusMaximum: this.getMaximumStatus,
        includeTestchecks: this.includeTestchecks
      };

      if (this.surveyValue)
      {
        let id = this.surveyValue.id.substring(1);
        result.surveyIds.push(id);
      }

      return result;
    },

    options: function() {
      let result = {
        isQualityAssurance: this.exportTypeValue !== ExportType.Customer,
        includeQuestionsWithoutAnswers: _.includes(this.includedDataValue, IncludedData.QuestionsWithoutAnswers),
        includeLocationInfo: _.includes(this.includedDataValue, IncludedData.LocationInfo),
        includeCheckInfo: _.includes(this.includedDataValue, IncludedData.CheckInfo),
        includeProperties: _.includes(this.includedDataValue, IncludedData.Properties),
        includeKpiPercentages: _.size(this.kpiValue) > 0,
        includeKpiPoints: this.hasPointSelection && this.includeKpiPoints && _.size(this.kpiValue) > 0,
        includeClusterPercentages: this.includeClusterPercentages,
        includeClusterPoints: this.hasPointSelection && this.includeClusterPercentages && this.includeClusterPoints,
        includeOverallPoints: this.hasPointSelection
      }
      return result;
    }
  },

  watch: {
    exportTypeValue: function () {
       this.selectDefaultKpis();

       this.includedDataValue = [
        IncludedData.LocationInfo,
        IncludedData.Properties,
        IncludedData.CheckInfo
      ];
      if (this.exportTypeQASelected)
        this.includedDataValue.push(IncludedData.QuestionsWithoutAnswers);
    }
  },

  mounted() {
    this.getSurveyStructure();

    EventBus.$on('LocalizationChanged', this.localizationChanged);
  },

  beforeDestroy() {
    EventBus.$off('LocalizationChanged', this.localizationChanged);
  },

  methods: {
    localizationChanged(localizationId) {
      this.getSurveyStructure();
    },

    // Get survey structure data for the structure treeselect
    getSurveyStructure() {
      SurveysService.getSurveyStructure()
        .then(response => {
          this.structureItems = response.data;
        })
    },

    // Get survey structure data for the structure treeselect
    getSurveyWaves() {
      if (!this.noSurveySelected)
      {
        SurveysService.getSurveyWaves(this.filter)
          .then(response => {
            this.waveItems = response.data;
          })
      };
    },

    // Get survey structure data for the structure treeselect
    getSurveyProperties() {
      if (!this.noSurveySelected)
      {
        SurveysService.getSurveyCustomProperties(this.filter, true)
          .then(response => {
            this.propertyItems = response.data;
          })
      };
    },

    // Get survey structure data for the scenario treeselect
    getSurveyScenarios() {
      if (!this.noSurveySelected)
      {
        SurveysService.getSurveyScenarios(this.filter)
          .then(response => {
            this.scenarioItems =  response.data;
          });
      }
    },

    selectDefaultKpis() {
      this.kpiValue = [];

      if (this.exportTypeCustomerSelected && !_.isEmpty(this.kpiItems))
        this.kpiValue.push(_.first(this.kpiItems));
    },

    // Get survey structure data for the structure treeselect
    getSurveyKpis() {
      if (!this.noSurveySelected)
      {
        SurveysService.getSurveyKpis({ surveyIds: this.surveyValue.id.substring(1) })
          .then(response => {
            // if only one survey selected/available, hide it
            if (response.data && response.data.length === 1 && response.data[0].children) {
              this.kpiItems = response.data[0].children;
            } else {
              this.kpiItems = [];
            }

            // Preselect all root items
            setTimeout(() => {
              this.selectDefaultKpis();
              this.includeClusterPercentages = _.size(this.kpiItems) === 0;
              this.includeClusterPoints = false;
            }, 0)
          })
      };
    },

    // Called whenever the input of the structure treeselect changes
    surveyFilterInput(value) {
      this.waveValue = [];
      this.propertyValue = [];
      this.kpiValue = [];
      this.targetGroupValue = null;
      this.targetGroups = [];

      this.getSurveyWaves();
      this.getSurveyProperties();
      this.getSurveyScenarios();
      this.getSurveyKpis();

      if (this.surveyValue && this.surveyValue.TargetGroups)
      {
        this.targetGroups = this.surveyValue.TargetGroups;
        if (this.targetGroups.length > 0)
          this.targetGroupValue = this.targetGroups[0];
      }
    },

    downloadRawData() {
      this.isExporting = true;
      this.noDataAlert = 0;

      let reportPromise = this.exportTypePointsSelected ?
        ReportsService.getRawDataIdPoints(this.filter, this.options) :
        ReportsService.getRawData(this.filter, this.options);

      reportPromise.then(response => {
          this.isExporting = false;

          if (response.status === 204)
            this.noDataAlert = 5;
          else
            this.downloadFile(response);
        })
        .catch(_ => { this.isExporting = false; } );
    }
  }
};
</script>
